module.exports = __webpack_public_path__ + "9c4e3450d16158f95c082a0e415317c9.pdf";